export default __webpack_public_path__ + "static/media/Back.9063653d.svg";